class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.closeTimeout = null;

    this.onHover = this.onHover.bind(this);
    this.onLeave = this.onLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onHoverMediaChange = this.onHoverMediaChange.bind(this);

    this.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
    this.querySelector('summary a')?.addEventListener('click', this.onParentLinkClick.bind(this));
    this.syncHoverListeners();

    if (this.hoverMediaQuery.addEventListener) {
      this.hoverMediaQuery.addEventListener('change', this.onHoverMediaChange);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.onHover);
    this.removeEventListener('pointerleave', this.onLeave);
    this.querySelector('summary')?.removeEventListener('click', this.onSummaryClick);
    if (this.hoverMediaQuery.removeEventListener) {
      this.hoverMediaQuery.removeEventListener('change', this.onHoverMediaChange);
    }
  }

  onHoverMediaChange() {
    this.syncHoverListeners();
  }

  syncHoverListeners() {
    this.removeEventListener('pointerenter', this.onHover);
    this.removeEventListener('pointerleave', this.onLeave);

    if (this.hoverMediaQuery.matches) {
      this.addEventListener('pointerenter', this.onHover);
      this.addEventListener('pointerleave', this.onLeave);
    }
  }

  onHover() {
    clearTimeout(this.closeTimeout);
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.classList.remove('is-revealed');
        details.removeAttribute('open');
      }
    });
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onLeave() {
    this.closeTimeout = setTimeout(() => this.close(), 180);
  }

  close() {
    this.mainDetailsToggle.classList.remove('is-revealed');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
  }

  revealMenu() {
    this.mainDetailsToggle.classList.remove('is-revealed');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (this.mainDetailsToggle.open) {
          this.mainDetailsToggle.classList.add('is-revealed');
        }
      });
    });
  }

  onParentLinkClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const href = event.currentTarget.getAttribute('href');
    if (href) window.location.assign(href);
  }

  onSummaryClick(event) {
    if (!this.hoverMediaQuery.matches || event.detail === 0) return;

    // Clicks on the parent collection link should navigate, not toggle the menu.
    if (event.target.closest('a')) return;

    event.preventDefault();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.revealMenu();
    } else {
      this.mainDetailsToggle.classList.remove('is-revealed');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
